import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DESKTOP_PANE } from '~/constants/desktopPanes';

export type AIPaneScreen =
    | { screen: 'list' }
    | { screen: 'details'; strategyId: string }
    | { screen: 'create'; templateUuid?: string; cloneStrategyId?: string };

export type DesktopState = {
    // null until the user picks one; Desktop falls back to the default watchlist.
    pane: number | null;
    aiScreen: AIPaneScreen;
};

const initialState: DesktopState = {
    pane: null,
    aiScreen: { screen: 'list' },
};

const desktopSlice = createSlice({
    name: 'desktop',
    initialState,
    reducers: {
        setPane: (state, { payload }: PayloadAction<number>) => {
            state.pane = payload;
            if (payload === DESKTOP_PANE.aiStrategy) {
                state.aiScreen = { screen: 'list' };
            }
        },
        setAIPaneScreen: (state, { payload }: PayloadAction<AIPaneScreen>) => {
            state.aiScreen = payload;
        },
        // One action for "show me this strategy" — it selects the pane and the screen together,
        // so nothing has to observe one and then set the other.
        openStrategyOnDesktop: (state, { payload }: PayloadAction<string>) => {
            state.pane = DESKTOP_PANE.aiStrategy;
            state.aiScreen = { screen: 'details', strategyId: payload };
        },
    },
});

export const { setPane, setAIPaneScreen, openStrategyOnDesktop } = desktopSlice.actions;

export default desktopSlice.reducer;
